<template>
    <div class="approval_process_node_wrap node">
        <div class="node_item" :class="'type_'+node.type">
            <div class="node_item_container" @click.stop="handleClickOpenSiteForm(node)" :class="computedClass">
                <div v-if="node.type!='route'" class="process_title_wrap">
                    <div :class="{'is_edit':node.type==='approval'||node.type==='conduct'}" class="process_title"
                         v-if="!node.is_edit">
                        <span v-text="node.name"></span>
                        <i @click.stop="handleClickEditTitle(node)" class="iconfont icon-bianji"
                           v-if="node.type==='approval'||node.type==='conduct' || (node.type==='condition' && node.name != '默认条件')"></i>
                    </div>
                    <div @click.stop  v-else style="width: 100%;">
                        <el-input @blur="handleTitleBlur($event,node)" clearable  maxlength="10" placeholder="这里可以输入标题"
                        ref="titleInput" size="mini" v-model="node.name">
                        </el-input>
                    </div>

                    <div class="process_copy_del" v-if="!node.is_edit">
                        <template>
                            <i class="el-icon-document-copy" v-if="node.type==='condition' && node.name != '默认条件'"
                               @click="handleCopyNode(node)"></i>
                            <i @click="handleClickDelIcon(node)" class="el-icon-close"
                               v-if="node.type==='approval'||node.type==='conduct' || (node.type==='condition' && node.name != '默认条件')"></i>
                        </template>
                        <div class="sort_text" v-if="node.type == 'condition'">优先级{{ node.sort + 1 }}</div>
                    </div>
                </div>
                <div v-if="node.type!='route'" class="set_up">
                        <span v-if="node.type != 'condition'">
                           <span v-text="siteTypeText(node)"></span>
                        </span>
                    <span v-if="node.type == 'condition'">
                           <span v-if="node.name == '默认条件'">用来补全条件，其他条件未满足时自动进入该条件</span>
                           <span v-else>
                             <span v-if="node.rules && node.rules.length>0 && node.rulesText" class="rulesText">
                               {{ node.rulesText }}
                             </span>
                             <span v-else>请设置条件</span>
                           </span>
                        </span>
                    <i v-if="node.name != '默认条件'" class="el-icon-arrow-right"></i>
                </div>

                <div class="del_btn_wrap" v-if="node.is_del">
                    <el-button @click="node.is_del=false" size="small">取消</el-button>
                    <el-button @click.stop="handleClickDelProcess(node)" size="small" type="danger">删除</el-button>
                </div>
                <template v-if="node.type == 'condition' && node.name != '默认条件'">
                    <div class="mobilePriorityLeft" v-if="node.sort != 0" @click="handleClickPriority(node,'left')">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <div class="mobilePriorityRight" @click="handleClickPriority(node,'right')"
                         v-if="!node.penultimate">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </template>
            </div>
            <div class="bottom-v-line" v-if="node.type != 'end'"></div>
            <div class="bottom-v-arrow" v-if="node.type != 'end' && node.childNode && node.childNode.type"></div>
            <div class="add-node-btn" v-if="node.type != 'end'">
                <el-popover ref="addPopover" placement="right" trigger="click" :width="canOperate == '1' ? 420 : 294">
                    <div slot="reference" class="add-btn" @click.stop="handleClickAddIcon(node)">+</div>
                    <ul class="add_option_list">
                        <li @click="handleClickAddProcess('approval',node)" class="add_option_item">
                            <img alt="" src="https://download.hecoos.com/enlightv/2024-46/c60fe2cb32e6cede1b2dd9001f0d7750.png">
                            <span>审批</span>
                        </li>
                        <li @click="handleClickAddProcess('conduct',node)" class="add_option_item">
                            <img alt="" src="https://download.hecoos.com/enlightv/2024-46/6dfbc929d43f209cf58dee1d2fd1e9c7.png">
                            <span>办理</span>
                        </li>
                        <li @click="handleClickAddProcess('condition',node)" class="add_option_item"
                            v-if="canOperate == '1'">
                            <img alt="" src="https://download.hecoos.com/enlightv/2023-51/ejDmNG454PMCanyS2tyX.svg">
                            <span>条件分支</span>
                        </li>
                    </ul>
                </el-popover>
            </div>
        </div>

        <!-- 条件-->
        <div class="conditionNodes" v-if="node.conditionNodes.length>0">
            <div class="top-h-line"></div>
            <div class="add-branch" @click="handleAddCondition(node)">+添加条件</div>
            <div class="branches">
                <div class="conditionNodes_item" v-for="child in node.conditionNodes">
                    <div class="top-line-mask"></div>
                    <div class="top-v-line"></div>
                    <div class="bottom-v-arrow"></div>
                    <div class="bottom-line-mask"></div>
                    <approveAdminProcessNode
                            :node="child"
                            :nodeUuid="nodeUuid"
                            :canOperate="canOperate"

                            @handleClickNode="(node)=>$emit('handleClickNode',node)" @nodeReceiveData="(node)=>$emit('nodeReceiveData',node)">
                    </approveAdminProcessNode>  <!-- 递归渲染子节点 -->
                    <div class="bottom-v-line"></div>
                </div>
            </div>
            <div class="bottom-h-line"></div>

        </div>
        <div v-if="node.childNode && node.childNode.type">
            <approveAdminProcessNode :node="node.childNode" :nodeUuid="nodeUuid" :canOperate="canOperate"
                                     @handleClickNode="(node)=>$emit('handleClickNode',node)" @nodeReceiveData="(node)=>$emit('nodeReceiveData',node)"
            ></approveAdminProcessNode>
            <!-- 递归渲染子节点 -->
        </div>


    </div>
</template>
<script>
import approveAdminProcessNode from './approvalProcessNode'

export default {
    name: "approveAdminProcessNode",
    components: {
        approveAdminProcessNode
    },
    props: {
        canOperate: {
            type: Number,
            default: 0,
        },
        node: {
            type: Object,
            default: () => {
            }
        },
        nodeUuid: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            userTypeList: [
                {
                    label: '直属上级',
                    value: 'superior'
                },
                {
                    label: '部门负责人',
                    value: 'department_head'
                },
                {
                    label: '指定成员',
                    value: 'specified'
                },
                {
                    label: '提交人自选',
                    value: 'submitter_choice'
                },
                {
                    label: '提交人本人',
                    value: 'submitter_self'
                },
                {
                    label: '人员标签',
                    value: 'user_tags'
                },
                {
                    label: '连续多级上级',
                    value: 'successive_superior'
                },
                {
                    label: '连续多级部门',
                    value: 'successive_department'
                },
            ]
        }
    },
    computed: {
        computedClass() {
            // 根据nodeUuid的值生成动态的class数组
            return [
                this.nodeUuid == this.node.uuid ? 'type_' + this.node.type + '_active' : ''
            ].filter(Boolean);
        }
    },
    methods: {
        // 点击单个传递给父组件
        handleClickOpenSiteForm(node) {
            if (node.type == 'condition' && node.name == '默认条件') {
                // this.$message.error('默认条件不可设置')
                return false
            }
            let data = {node: node, nodeUuid: node.uuid}
            this.$emit('handleClickNode', data);
        },

        handleClickAddIcon() {

        },
        // 添加审批,办理,条件分支
        handleClickAddProcess(type, node) {
            switch (type) {
                case 'approval': //添加审批节点
                    var oldChildNode = JSON.parse(JSON.stringify(node.childNode))
                    var oldConditionNodes = JSON.parse(JSON.stringify(node.conditionNodes))
                    var newNode = {
                        type: 'approval',
                        name: '审批',
                        sort: 0,
                        level: 0,
                        allow_transfer: 0,
                        allow_add_signature: 0,
                        allow_return: 0,
                        handle: {},
                        cc_info: [],
                        rules: [],
                        field_auth:[],//表单权限
                        childNode: oldChildNode,
                        conditionNodes: oldConditionNodes
                    }
                    node.conditionNodes = []
                    node.childNode = JSON.parse(JSON.stringify(newNode))
                    var data = {
                        node: node,
                        type: 'add'
                    }
                    this.$emit('nodeReceiveData', data);
                    break
                case 'conduct':  //添加办理节点 // 添加审批----把原有的数据保留一份  然后把原有的变为添加的数据  childNode = 原有的node  conditionNodes 清空
                    var oldChildNode = JSON.parse(JSON.stringify(node.childNode))
                    var oldConditionNodes = JSON.parse(JSON.stringify(node.conditionNodes))
                    var newNode = {
                        type: 'conduct',
                        name: '办理',
                        sort: 0,
                        level: 0,
                        allow_transfer:0,
                        allow_add_signature: 0,
                        allow_return: 0,
                        handle: {},
                        cc_info: [],
                        rules: [],
                        field_auth:[],//表单权限
                        childNode: oldChildNode,
                        conditionNodes: oldConditionNodes
                    }
                    node.conditionNodes = []
                    node.childNode = JSON.parse(JSON.stringify(newNode))
                    var data = {
                        node: node,
                        type: 'add'
                    }
                    this.$emit('nodeReceiveData', data);
                    break
                case 'condition':  //添加条件分支节点
                    var newElement = [
                        {
                            type: "condition",
                            name: `条件1`,
                            sort: 0,
                            level: 0,
                            allow_transfer: 0,
                            allow_add_signature:0,
                            allow_return: 0,
                            handle: {},
                            cc_info: [],
                            rules: [],
                            childNode: {
                                type: "approval",
                                name: "审批",
                                sort: 0,
                                level: 0,
                                allow_transfer: 0,
                                allow_add_signature:0,
                                allow_return: 0,
                                handle: {},
                                cc_info: [],
                                rules: [],
                                field_auth:[],//表单权限
                                childNode: {},
                                conditionNodes: [],
                            },
                            conditionNodes: []
                        },
                        {
                            type: "condition",
                            name: `默认条件`,
                            sort: 0,
                            level: 0,
                            allow_transfer: 0,
                            allow_add_signature: 0,
                            allow_return: 0,
                            handle: {},
                            cc_info: [],
                            rules: [],
                            childNode: {
                                type: "approval",
                                name: "审批",
                                sort: 0,
                                level: 0,
                                allow_transfer: 0,
                                allow_add_signature: 0,
                                allow_return: 0,
                                handle: {},
                                cc_info: [],
                                rules: [],
                                field_auth:[],//表单权限
                                childNode: {},
                                conditionNodes: [],
                            },
                            conditionNodes: []
                        }
                    ]
                    // 在谁下面添加条件，就在谁下面的conditionNodes字段添加两个默认数据；同时修改他的childNode，在childNode里面，再套一层route
                    var oldChildNode = JSON.parse(JSON.stringify(node.childNode))
                    var oldConditionNodes = JSON.parse(JSON.stringify(node.conditionNodes))
                    var newNode = {
                        type: "route",
                        name: "路由",
                        childNode: oldChildNode,
                        conditionNodes: oldConditionNodes
                    }
                    node.childNode = newNode
                    node.conditionNodes = newElement
                    var data = {
                        node: node,
                        type: 'add'
                    }
                    this.$emit('nodeReceiveData', data);
                    break
            }

            if (this.$refs.addPopover) {
                this.$refs.addPopover.doClose()
            }
        },
        // 添加一个条件
        handleAddCondition(node) {
            let newElement =
                    {
                        type: "condition",
                        name: `条件${node.conditionNodes.length}`,
                        sort: 0,
                        level: 0,
                        allow_transfer: 0,
                        allow_add_signature: 0,
                        allow_return:0,
                        handle: {},
                        cc_info: [],
                        rules: [],
                        childNode: {
                            type: "approval",
                            name: "审批",
                            sort: 0,
                            level: 0,
                            allow_transfer:0,
                            allow_add_signature: 0,
                            allow_return: 0,
                            handle: {},
                            cc_info: [],
                            rules: [],
                            field_auth:[],//表单权限
                            childNode: {},
                            conditionNodes: [],
                        },
                        conditionNodes: []
                    }
            var lastIdx = node.conditionNodes.length - 1;
            node.conditionNodes.splice(lastIdx, 0, newElement); // 再用 splice 在最后一个元素之前插入一个副本
            let data = {
                node: node,
                type: 'add'
            }
            this.$emit('nodeReceiveData', data);
        },
        // 复制条件
        handleCopyNode(node) {
            let data = {
                node: node,
                type: 'copy'
            }
            this.$emit('nodeReceiveData', data);
        },
        // 移动条件分支
        handleClickPriority(node, direction) {
            let data = {
                node: node,
                type: 'sort',
                direction: direction
            }
            this.$emit('nodeReceiveData', data);
        },
        // 删除出现
        handleClickDelIcon(item) {
            this.$set(item, 'is_del', true)
        },
        // 确认删除
        handleClickDelProcess(node) {
            this.$set(node, 'is_del', false)
            let data = {
                node: node,
                type: 'del'
            }
            this.$emit('nodeReceiveData', data);
        },
        // 编辑标题
        handleClickEditTitle(item) {
            this.$set(item, 'is_edit', true)
            this.$nextTick(() => {
                if (this.$refs.titleInput[0]) {
                    this.$refs.titleInput[0].focus()
                } else if (this.$refs.titleInput) {
                    this.$refs.titleInput.focus()
                }
            })
        },
        // 编辑标题失去焦点
        handleTitleBlur(val, item) {
            if (!item.name) return this.$message.error('请输入标题')
            this.$set(item, 'is_edit', false)
            let data = {
                node: item,
                type: 'add'
            }
            this.$emit('nodeReceiveData', data);
        },

        siteTypeText(item) {
            let str = ''

            switch (item.type) {
                case 'start':
                    if (item.cc_info.length === 0) {
                        str = '可设置抄送人'
                    } else if (item.cc_info && item.cc_info.length === 1) {
                        str = this.userTypeList.find(type => type.value === item.cc_info[0].type).label
                    } else if (item.cc_info && item.cc_info.length > 1) {
                        str = this.userTypeList.find(type => type.value === item.cc_info[0].type).label + '...'
                    }
                    break
                case 'approval':
                    if (item.handle && item.handle.type) {
                        if (item.handle.operation_type == 'auto_approve') {
                            str = '系统自动通过'
                        } else if (item.handle.operation_type == 'auto_deny') {
                            str = '系统自动拒绝'
                        } else {
                            str = this.userTypeList.find(type => type.value === item.handle.type).label
                        }

                    } else {
                        str = '可设置审批人'
                    }
                    break
                case 'conduct':
                    if (item.handle && item.handle.type) {
                        str = this.userTypeList.find(type => type.value === item.handle.type).label
                    } else {
                        str = '可设置办理人'
                    }
                    break
                case 'end':
                    if (item.cc_info.length === 0) {
                        str = '可设置抄送人'
                    } else if (item.cc_info.length === 1) {
                        str = this.userTypeList.find(type => type.value === item.cc_info[0].type).label
                    } else if (item.cc_info.length > 1) {
                        str = this.userTypeList.find(type => type.value === item.cc_info[0].type).label + '...'
                    }
                    break
            }
            return str
        },

    }
}
</script>
<style lang="scss" scoped>
.approval_process_node_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    .node_item {
        position: relative;
        .node_item_container {
            width: 261px;
            height: 96px;
            border-radius: 4px;
            padding:8px 12px 12px;
            margin-bottom: 60px;
            position: relative;
            z-index: 10;
            .title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 8px;
            }
            .process_title_wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 4px;
                .process_title {
                    font-size: 12px;
                    line-height: 26px;
                    color: #333333;
                    padding: 0 4px;
                    height: 26px;
                    overflow: hidden;
                    &.is_edit:hover {
                        border-radius: 4px;
                        background: rgba(0, 0, 0, 0.08);
                    }
                    .icon-bianji {
                        display: none;
                        font-size: 12px;
                        margin-left: 4px;
                    }
                    &:hover .icon-bianji {
                        display: inline-block;
                        cursor: pointer;
                    }
                }
                .el-icon-close {
                    color: #666666;
                    cursor: pointer;
                }
                .el-icon-document-copy {
                    color: #666666;
                    cursor: pointer;
                }
                .el-input{
                    ::v-deep .el-input__inner{
                        color: rgba(51, 51, 51, 1);
                        height: 26px;
                        line-height: 26px;
                        border:0;
                        border-radius: 2px;
                        background: rgba(0, 0, 0, 0.08);
                        &::placeholder{
                            color: #333;
                        }
                    }
                    ::v-deep .el-input__icon{
                        line-height: 26px;
                        font-size: 14px;
                        color: #333;
                        cursor: pointer;
                    }
                }
            }
            &.type_start_active {
                box-shadow: 0 3px 6px 2px rgba(223, 230, 237, 0.5);
            }
            &.type_approval_active {
                box-shadow: 0 3px 6px 2px rgba(255, 161, 87, 0.36);
            }
            &.type_conduct_active {
                box-shadow: 0 3px 6px 2px rgba(168, 158, 255, 0.36);
            }
            &.type_condition_active {
                box-shadow: 0px 3px 8px 4px rgba(0, 0, 0, 0.12) !important;
            }
            &.type_end_active {
                box-shadow: 0 3px 6px 2px rgba(202, 214, 227, 0.5);
            }
            .set_up {
                width: 100%;
                height: 46px;
                opacity: 1;
                border-radius: 4px;
                background: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 12px;
                cursor: pointer;
                span{
                    font-size:14px;
                    color:rgba(51, 51, 51, 1)
                }
            }
            .mobilePriorityLeft {
                width: 10px;
                height: 96px;
                background: rgba(255, 255, 255, 0.06);
                box-shadow: 1px 0px 2px -1px rgba(0, 0, 0, 0.16);
                position: absolute;
                line-height: 96px;
                text-align: center;
                font-size: 12px;
                color: rgba(102, 102, 102, 1);
                left: 0;
                top: 0;
                cursor: pointer;
                display: none;
            }
            .mobilePriorityRight {
                width: 10px;
                height: 96px;
                background: rgba(255, 255, 255, 0.06);
                box-shadow: 1px 0px 10px -1px rgba(0, 0, 0, 0.16);
                position: absolute;
                line-height: 96px;
                text-align: center;
                font-size: 12px;
                color: rgba(102, 102, 102, 1);
                right: 0;
                top: 0;
                cursor: pointer;
                display: none;
            }
            &:hover .mobilePriorityLeft,&:hover .mobilePriorityRight{
                display: block;
            }
            .process_copy_del {
                min-width: 60px;
                height: 26px;
                line-height: 26px;
                position: relative;
                text-align: right;
                .sort_text {
                    position: absolute;
                    right: 0;
                    font-size: 12px;
                    color: rgba(51, 51, 51, 1);
                    top: 0;
                    background: #fff;
                    line-height: 26px;
                }
            }
            &:hover .process_copy_del .sort_text {
                display: none;
            }
        }
        &.type_start .node_item_container {
            background: #DFE6ED;
        }
        &.type_conduct .node_item_container {
            background: #A89EFF
        }
        &.type_end .node_item_container {
            background: #CAD6E3;
        }
        &.type_approval .node_item_container {
            background: #FAC69D;
        }
        &.type_condition .node_item_container {
            background: #fff;
            box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.08);
            .set_up {
                background: rgba(247, 248, 250, 1) !important;
            }
        }
        &.type_route{
            & > .bottom-v-line {
                height: 100px;
                width: 1px;
                background-color: #c2c5cc;
                align-self: center;
            }
            .node_item_container {
                height: 40px;
            }
        }

        .bottom-v-line {
            position: absolute;
            bottom: 0;
            left: 130px;
            height: 150px;
            width: 1px;
            background-color: #c2c5cc;
        }
        .bottom-v-arrow {
            position: absolute;
            bottom: 0;
            width: 10px;
            height: 10px;
            left: calc(50% - 5px);
            -webkit-transform: matrix(1, 0, 0, -1, 0, 0);
            transform: matrix(1, 0, 0, -1, 0, 0);
            border-bottom: 10px solid #c2c5cc;
            border-right: 5px solid transparent;
            border-left: 5px solid transparent;
            background-color: #fff;
        }
        .add-node-btn {
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            width: 28px;
            height: 28px;
            border-radius: 50%;
            border: 1px solid transparent;
            .add-btn {
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background-color: #fff;
                color: #37f;
                outline: none;
                cursor: pointer;
                -webkit-filter: drop-shadow(0 4px 8px rgba(31, 35, 41, .1));
                filter: drop-shadow(0 4px 8px rgba(31, 35, 41, .1));
                &:hover,&:active{
                    border: 1px solid rgba(25, 144, 255, 1);
                    box-shadow: 0px 2px 4px 2px rgba(25, 144, 255, 0.24);
                }

            }
        }
    }

    .conditionNodes {
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: relative;
        &>.top-h-line {
            transform: translateY(-11px);
            height: 1px;
            background-color: #c2c5cc;
            margin-top: 14.5px;
            margin-bottom: -15.5px;
            width: calc(100% - 200px);
            margin-left: 100px;
        }
        &>.add-branch {
            top: -11px;
            position: relative;
            height: 30px;
            line-height: 30px;
            margin-bottom: 16px;
            border-radius: 15px;
            border: 1px solid transparent;
            align-self: center;
            color: #37f;
            font-size: 12px;
            cursor: pointer;
            box-shadow: 0 4px 8px rgba(31, 35, 41, .1);
            z-index: 10;
            background: #fff;
            padding: 0 12px;
            &:hover {
                border: 1px solid #37f;
                box-shadow: 0px 0px 5px rgba(31, 35, 41, .3)
            }
        }
        &>.branches {
            display: flex;
            justify-content: center;
        }
        &>.bottom-h-line {
            height: 1px;
            background-color: #c2c5cc;
            width: calc(100% - 200px);
            margin-left: 100px;
        }
        .conditionNodes_item {
            margin: 0 15px;
            position: relative;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            &:first-child>.top-line-mask, &:last-child>.top-line-mask{
                display: block;
                position: absolute;
                width: 50%;
                height: 4px;
                background-color: #fff;
                top: -44px;
            }
            &:first-child>.bottom-line-mask, &:last-child>.bottom-line-mask{
                display: block;
                position: absolute;
                width: 50%;
                height: 4px;
                background-color: #fff;
                bottom: -4px;
            }
            &:first-child > .top-line-mask, &:first-child > .bottom-line-mask {
                left: 0;
            }
            &:last-child > .top-line-mask, &:last-child > .bottom-line-mask {
                right: 0;
            }
            .bottom-v-line {
                display: block;
                width: 1px;
                background-color: #c2c5cc;
                flex-grow: 1;
            }
            .top-v-line {
                height: 42.5px;
                top: -42.5px;
                left: calc(50% - 0.5px);
                display: block;
                position: absolute;
                width: 1px;
                background-color: #c2c5cc;
            }
        }
    }
    .del_btn_wrap {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        .el-button:first-child{
            background: #fff;
        }
    }
}


.add_option_list {
    display: flex;
    justify-content: space-between;
    .add_option_item {
        width: 128px;
        height: 48px;
        border-radius: 4px;
        background: #F7F8FA;
        padding: 8px;
        display: flex;
        align-items: center;
        &:hover {
            background: #FFFFFF;
            box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.08);
            cursor: pointer;
        }
        img{
            width: 32px;
        }
        span {
            color:rgba(51, 51, 51, 1);
            line-height: 22px;
            display: inline-block;
            margin-left: 10px;
            font-size: 12px
        }
    }
}


.rulesText {
    line-height: 19px;
    height: 38px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 设置最大显示行数 */
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
}

</style>
